import { AbstractControl, ValidatorFn } from "@angular/forms";

export function serieCIValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const value = control.value;
        const regex = /^[a-zA-Z]{2}$/;

        if (value && !regex.test(value)) {
            return { invalidSerieCI: true };
        }

        return null;
    };
}